// ink-component
import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';
import getGlobalProps from '../../../../helpers/constants/global-props';

export interface PageHeaderProps extends HTMLAttributes<HTMLDivElement> {}

const PageHeaderElement = styled.div<HTMLAttributes<HTMLDivElement>>`
  margin: 20px 0 24px;
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Arranges page title and global actions
 * @group Page
 */
export function PageHeader(props: PageHeaderProps) {
  const { className, style, ...otherProps } = props;

  return <PageHeaderElement {...otherProps} {...globalProps} />;
}

PageHeader.displayName = 'Page.Header';

export default PageHeader;
